<section class="mb-7 mt-5">
  <div class="w-fit">
    <h2 class="text-47 mb-5 flex flex-wrap justify-center font-bold gap-x-2">
      <span>{{
        "frequently-asked-questions_subtitle_general_questions" | translate
      }}</span>
    </h2>
  </div>

  <div class="bg-[#F4F4F4] dark:bg-[#0F0F0F] w-full rounded mt-4 lg:mt-7 mb-5">
    <mat-accordion multi>
      <mat-expansion-panel hideToggle (expandedChange)="onExpandChange(0)">
        <mat-expansion-panel-header
          class="!h-auto dark:hover:!bg-[#202020] dark:focus-active:!bg-[#202020] hover:!bg-[#f0efef] focus-active:!bg-[#f0efef] text-ayr-black dark:text-white"
        >
          <mat-panel-title>
            <div
              class="text-ayr-black dark:text-white flex items-center gap-2 teste"
            >
              @if (darkMode) {
                <img
                  class="duration-200"
                  [ngClass]="{ 'rotate-90': principalAccordion[0].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right-dark.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
              }
              @if (!darkMode) {
                <img
                  class="duration-200"
                  [ngClass]="{ 'rotate-90': principalAccordion[0].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
              }
              <span class="dark:text-white">{{
                "frequently-asked-questions_what_is_the_AYR" | translate
              }}</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="mat-expansion-content text-ayr-black dark:text-white">
          <p class="!text-ayr-black dark:!text-white">
            {{ "frequently-asked-questions_what_is_the_AYR_1" | translate }}
          </p>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel hideToggle (expandedChange)="onExpandChange(1)">
        <mat-expansion-panel-header
          class="!h-auto dark:hover:!bg-[#202020] dark:focus-active:!bg-[#202020] hover:!bg-[#f0efef] focus-active:!bg-[#f0efef] text-ayr-black dark:text-white"
        >
          <mat-panel-title>
            <div class="text-ayr-black dark:text-white flex items-center gap-2">
              @if (darkMode) {
                <img
                  class="duration-200"
                  [ngClass]="{ 'rotate-90': principalAccordion[1].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right-dark.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
              }
              @if (!darkMode) {
                <img
                  class="duration-200"
                  [ngClass]="{ 'rotate-90': principalAccordion[1].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
              }
              <span class="dark:text-white">{{
                "frequently-asked-questions_who_can_use_AYR" | translate
              }}</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="mat-expansion-content text-ayr-black dark:text-white">
          <p class="!text-ayr-black dark:!text-white">
            {{ "frequently-asked-questions_who_can_use_AYR_1" | translate }}
          </p>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel hideToggle (expandedChange)="onExpandChange(2)">
        <mat-expansion-panel-header
          class="!h-auto dark:hover:!bg-[#202020] dark:focus-active:!bg-[#202020] hover:!bg-[#f0efef] focus-active:!bg-[#f0efef] text-ayr-black dark:text-white"
        >
          <mat-panel-title>
            <div class="text-ayr-black dark:text-white flex items-center gap-2">
              @if (darkMode) {
                <img
                  class="duration-200"
                  [ngClass]="{ 'rotate-90': principalAccordion[2].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right-dark.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
              }
              @if (!darkMode) {
                <img
                  class="duration-200"
                  [ngClass]="{ 'rotate-90': principalAccordion[2].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
              }
              <span class="dark:text-white">{{
                "frequently-asked-questions_what_sustainable_activities"
                  | translate
              }}</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="mat-expansion-content text-ayr-black dark:text-white">
          <p class="!text-ayr-black dark:!text-white">
            {{
              "frequently-asked-questions_what_sustainable_activities_1"
                | translate
            }}
          </p>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel hideToggle (expandedChange)="onExpandChange(3)">
        <mat-expansion-panel-header
          class="!h-auto dark:hover:!bg-[#202020] dark:focus-active:!bg-[#202020] hover:!bg-[#f0efef] focus-active:!bg-[#f0efef] text-ayr-black dark:text-white"
        >
          <mat-panel-title>
            <div class="text-ayr-black dark:text-white flex items-center gap-2">
              @if (darkMode) {
                <img
                  class="duration-200"
                  [ngClass]="{ 'rotate-90': principalAccordion[3].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right-dark.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
              }
              @if (!darkMode) {
                <img
                  class="duration-200"
                  [ngClass]="{ 'rotate-90': principalAccordion[3].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
              }
              <span class="dark:text-white">{{
                "frequently-asked-questions_how_does_the_AYR_mobile_app"
                  | translate
              }}</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="mat-expansion-content text-ayr-black dark:text-white">
          <p class="!text-ayr-black dark:!text-white">
            {{
              "frequently-asked-questions_how_does_the_AYR_mobile_app_1"
                | translate
            }}
          </p>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel hideToggle (expandedChange)="onExpandChange(4)">
        <mat-expansion-panel-header
          class="!h-auto dark:hover:!bg-[#202020] dark:focus-active:!bg-[#202020] hover:!bg-[#f0efef] focus-active:!bg-[#f0efef] text-ayr-black dark:text-white"
        >
          <mat-panel-title>
            <div class="text-ayr-black dark:text-white flex items-center gap-2">
              @if (darkMode) {
                <img
                  class="duration-200"
                  [ngClass]="{ 'rotate-90': principalAccordion[4].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right-dark.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
              }
              @if (!darkMode) {
                <img
                  class="duration-200"
                  [ngClass]="{ 'rotate-90': principalAccordion[4].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
              }
              <span class="dark:text-white">{{
                "frequently-asked-questions_where_can_I_download" | translate
              }}</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="mat-expansion-content text-ayr-black dark:text-white">
          <p class="!text-ayr-black dark:!text-white">
            {{
              "frequently-asked-questions_where_can_I_download_1" | translate
            }}
          </p>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel hideToggle (expandedChange)="onExpandChange(5)">
        <mat-expansion-panel-header
          class="!h-auto dark:hover:!bg-[#202020] dark:focus-active:!bg-[#202020] hover:!bg-[#f0efef] focus-active:!bg-[#f0efef] text-ayr-black dark:text-white"
        >
          <mat-panel-title>
            <div class="text-ayr-black dark:text-white flex items-center gap-2">
              @if (darkMode) {
                <img
                  class="duration-200"
                  [ngClass]="{ 'rotate-90': principalAccordion[5].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right-dark.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
              }
              @if (!darkMode) {
                <img
                  class="duration-200"
                  [ngClass]="{ 'rotate-90': principalAccordion[5].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
              }
              <span class="dark:text-white">{{
                "frequently-asked-questions_is_the_AYR_mobile_app_free_to_use"
                  | translate
              }}</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="mat-expansion-content text-ayr-black dark:text-white">
          <p class="!text-ayr-black dark:!text-white">
            {{
              "frequently-asked-questions_is_the_AYR_mobile_app_free_to_use_1"
                | translate
            }}
          </p>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel hideToggle (expandedChange)="onExpandChange(6)">
        <mat-expansion-panel-header
          class="!h-auto dark:hover:!bg-[#202020] dark:focus-active:!bg-[#202020] hover:!bg-[#f0efef] focus-active:!bg-[#f0efef] text-ayr-black dark:text-white"
        >
          <mat-panel-title>
            <div class="text-ayr-black dark:text-white flex items-center gap-2">
              @if (darkMode) {
                <img
                  class="duration-200"
                  [ngClass]="{ 'rotate-90': principalAccordion[6].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right-dark.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
              }
              @if (!darkMode) {
                <img
                  class="duration-200"
                  [ngClass]="{ 'rotate-90': principalAccordion[6].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
              }
              <span class="dark:text-white">{{
                "frequently-asked-questions_what_are_AYR_tokens" | translate
              }}</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="mat-expansion-content text-ayr-black dark:text-white">
          <p class="!text-ayr-black dark:!text-white">
            {{ "frequently-asked-questions_what_are_AYR_tokens_1" | translate }}
          </p>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</section>
